import React, { ReactNode } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider } from '@user-portal/wikr-components';

import { getCustomProperties } from './helpers';

import GlobalStyle from './global-styles';
import themeConfig from './themeConfig';

interface ThemeProviderProps {
    children: ReactNode;
}

const { theme, inline } = themeConfig;

const Provider = ({ children }: ThemeProviderProps) => {
    return (
        <StyledThemeProvider theme={theme}>
            <ThemeProvider theme={theme}>
                <GlobalStyle rootVariables={getCustomProperties(inline)} theme={theme} />
                {children}
            </ThemeProvider>
        </StyledThemeProvider>
    );
};

export default Provider;
